import { useMutation } from "@apollo/client/react";
import Stack from '@mui/material/Stack';
import {
	DialogTitle,
	DialogActions,
	DialogContent,
	Button,
} from 'components/dialogs/DialogBox';

import ErrorMessage from 'components/ErrorMessage';

import Form from 'web/form/Form';
import {
	AddressFields,
	CountryAutocomplete,
} from 'web/components/user/UserInputFields';

import { VERIFY_ONE_USER_ADDRESS } from 'api/mutations/userMutations';

export default function AddressVerifyModal({ _id, verificationAddress }) {
	const [verifyUserAddress, { loading, error }] = useMutation(
		VERIFY_ONE_USER_ADDRESS,
		{
			refetchQueries: ['currentUser'],
		}
	);

	const handleSubmit = async ({
		street_address,
		postal_code,
		locality,
		country,
	}) => {
		try {
			await verifyUserAddress({
				variables: {
					_id: _id,
					address: {
						street_address,
						postal_code,
						locality: locality.toUpperCase(),
						country,
					},
				},
			});
		} catch (err) {
			console.warn(err);
		}
	};

	return (
		<>
			<DialogTitle id="user-verification-dialog-title">
				Vennligst bekreft adressen din
			</DialogTitle>

			<ErrorMessage errors={[error]} />

			<Form values={{ ...verificationAddress }} onSubmit={handleSubmit}>
				<DialogContent>
					<Stack spacing={3}>
						<AddressFields />

						<CountryAutocomplete />
					</Stack>
				</DialogContent>

				<DialogActions>
					<Button
						type="submit"
						variant="contained"
						color="primary"
						loading={loading}
					>
						Bekreft adresse
					</Button>
				</DialogActions>
			</Form>
		</>
	);
}
